// Stickers LINE lets any Official Account send through the Messaging API.
// Keep in sync with app/services/line/sticker_catalog.rb, which validates what is sent.
// Source: https://developers.line.biz/en/docs/messaging-api/sticker-list/
// Each package is a consecutive range of sticker ids.
const range = (first, count) =>
  Array.from({ length: count }, (_, i) => first + i);

export const LINE_STICKER_PACKAGES = [
  { packageId: '446', stickerIds: range(1988, 40) },
  { packageId: '789', stickerIds: range(10855, 40) },
  { packageId: '6370', stickerIds: range(11088016, 24) },
  { packageId: '11537', stickerIds: range(52002734, 40) },
  { packageId: '11538', stickerIds: range(51626494, 40) },
  { packageId: '11539', stickerIds: range(52114110, 40) },
];

export const lineStickerImageUrl = stickerId =>
  `https://stickershop.line-scdn.net/stickershop/v1/sticker/${stickerId}/android/sticker.png`;
